import React, { useEffect, useRef, useState } from 'react';
import ENUMS from '../../enums/index';
import Select from 'react-select';
import './financialTransactions.scss';
import DatePicker from '../../components/FormElements/DatePicker/DatePicker';

const FinancialTransactionsFilter = props => {
  let formReference = useRef();

  let [selectedType, setSelectedTypes] = useState([]);
  let [userFullNamePart, setUserFullNamePart] = useState('');
  let [userMobileNumberPart, setUserMobileNumberPart] = useState();
  let [createdDateFrom, setCreatedDateFrom] = useState(' ');
  let [createdDateTo, setCreatedDateTo] = useState(' ');
  let [trackingNumberPart, setTrackingNumberPart] = useState();

  const resetForm = event => {
    Array.from(formReference.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setSelectedTypes('');
    setCreatedDateFrom(' ');
    setCreatedDateTo(' ');
    setTrackingNumberPart('');
    setUserFullNamePart('');
    setUserMobileNumberPart('');
    props.applyFilters(event);
  };

  return (
    <form
      ref={formReference}
      onReset={event => resetForm(event)}
      onSubmit={event => props.applyFilters(event)}
      id="filterForm"
      className="card p-3 mb-3"
    >
      <strong className="mb-3">{locales('titles.search')}</strong>

      <div className="form-row">
        <div className="col-md-6 col-sm-12 pb-3">
          <div className="form-group row">
            <label htmlFor="type" className="col-2">
              {locales('labels.financial.transaction.type')}
            </label>
            <div className="col-10">
              <Select
                placeholder={locales('placeholders.financial.transaction.type')}
                name="type"
                value={selectedType}
                options={ENUMS.FINANCIAL_TRANSACTION_TYPES.list.map(type => ({
                  label: type.title,
                  value: type.value
                }))}
                onChange={selectedIds => setSelectedTypes(selectedIds)}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="form-group row">
            <label htmlFor="type" className="col-2 col-form-label">
              {locales('labels.financial.transaction.userFullName')}
            </label>
            <div className="d-flex flex-column col-10">
              <input
                onChange={event => setUserFullNamePart(event.target.value)}
                value={userFullNamePart || ''}
                name="userFullNamePart"
                type="text"
                className="form-control"
                placeholder={locales('placeholders.financial.transaction.full.name')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-6 col-sm-12">
          <div className="form-group row">
            <label htmlFor="type" className="col-4 col-form-label">
              {locales('labels.financial.transaction.userMobileNumber')}
            </label>
            <div className="col-8">
              <input
                onChange={event => setUserMobileNumberPart(event.target.value)}
                value={userMobileNumberPart || ''}
                name="userMobileNumberPart"
                type="text"
                className="form-control"
                placeholder={locales('placeholders.financial.transaction.mobile.number')}
                maxLength={ENUMS.MAX_LENGTH.mobileNumber}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group row">
            <div className="col-6">
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع"
                onChange={d => setCreatedDateFrom(d)}
                name="startDate1"
                value={createdDateFrom}
                className="form-control start"
              />
            </div>
            <div className="col-6">
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان"
                name="endDate1"
                onChange={d => setCreatedDateTo(d)}
                value={createdDateTo}
                className="form-control start"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-6 col-sm-12">
          <div className="form-group row">
            <label htmlFor="type" className="col-3 col-form-label">
              {locales('tables.trackingCodePayment')}
            </label>
            <div className="col-9">
              <input
                onChange={event => setTrackingNumberPart(event.target.value)}
                value={trackingNumberPart || ''}
                name="trackingNumberPart"
                type="text"
                className="form-control"
                placeholder={locales('tables.trackingCodePayment')}
                maxLength={ENUMS.MAX_LENGTH.trackingNumber}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-12 text-left">
          <input
            name="resetButton"
            type="reset"
            value={locales('fields.reset')}
            className="btn btn-danger w-5 mx-2"
          />
          <button id="apply-filter-btn-financialTransactions" type="submit" className="btn btn-success mr-3">
            {locales('fields.applyFilters')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default FinancialTransactionsFilter;
